export const QuestionsList = [
  {
    service: 'PVO',
    title: 'PVO',
    sections: [
      {
        title: 'Besparelsesoverblik',
        questions: [
          {
            title: 'Hvor ser jeg energibesparelsen for min bygning?',
            answer: (
              <>
                Under <b>Besparelsesoverblik</b> kan du trykke på den enkelte
                bygning og se det samlede forbrug med og uden vores optimering
                og dermed den samlede kWh- og CO2e-besparelse. Her har du selv
                mulighed for at indtaste CO2e-koefficienten for bygningen
                således den nøjagtige CO2-ækvivalente besparelse vises.
                <br />
                <br />
                Derudover kan du se det aflæste forbrug for den enkelte dag samt
                hvilke 9 dage vi aktivt styrer varmen i bygningen og den 10.
                dag, hvor vi slukker for vores optimering og bygningen derfor
                kører sin normale drift.
              </>
            ),
          },
          {
            title: 'Hvorfor kan jeg ikke se besparelsen lige nu?',
            answer: (
              <>
                Da besparelsen er baseret på forbruget med og uden vores
                optimering, kræver det tilstrækkeligt med dage med data fra
                bygningen, for at kunne se energibesparelsen. Der kan derfor i
                starten af optimeringsperioden eller varmesæsonen potentielt
                være for lidt data, til at kunne angive besparelsen. I takt med
                at der kommer flere aktive- og baseline-dage kommer der også
                mere sammenligningsdata, og besparelsen kan derfor angives.
              </>
            ),
          },
          {
            title: 'Hvor kommer energidataene fra?',
            answer: (
              <>
                Energidataene og kWh-forbruget kommer fra jeres egen
                afregningsmåler. Det er altså hovedmålerdata direkte fra måleren
                eller via en data-integration med jeres forsyningsselskab, som
                vi bruger.
              </>
            ),
          },
        ],
      },
      {
        title: 'Kalender',
        questions: [
          {
            title: 'Hvordan opretter jeg en begivenhed i kalenderfunktionen?',
            answer: (
              <>
                I kalenderoverblikket markerer du dagen og tidsperioden for
                begivenheden. Herefter navngiver du begivenheden eks.{' '}
                <i>elevsamtaler</i> og indtaster det nøjagtige start- og
                sluttidspunktet for begivenheden samt at bygningen er i brug.
                <br />
                <br />
                Til slut markerer du de blandesløjfer som dækker de
                bygningsdele, hvor begivenheden bliver afholdt og trykker{' '}
                <b>opret begivenhed</b>. Herefter ser du begivenheden fremgå i
                kalenderoverblikket.
              </>
            ),
          },
          {
            title: 'Hvordan lægger jeg en ferie ind i kalenderfunktionen?',
            answer: (
              <>
                I kalenderoverblikket markerer du de dage ferien finder sted.
                Herefter navngiver du ferien og indtaster start og sluttidspunkt
                for ferien samt at bygningen ikke er i brug.
                <br />
                <br />
                Til sidst markerer du de blandesløjfer, der dækker de
                bygningsdele, der ikke er i brug under ferien og trykker{' '}
                <b>opret begivenhed</b>. Herefter ser du ferien fremgå i
                kalenderoverblikket.
              </>
            ),
          },
          {
            title: 'Hvor lang tid i forvejen skal jeg oprette en begivenhed?',
            answer: (
              <>
                Når du opretter en begivenhed i kalenderen, vil styringen blive
                justeret inden for få minutter, så opvarmningen passer til
                begivenheden. Hvis begivenheden finder sted på en dag, hvor
                bygningen normalt ikke er i brug, som f.eks. i ferier eller
                weekender, anbefaler vi, at du opretter begivenheden senest
                dagen før, således komforttemperaturen sikres i tidsrummet for
                begivenheden.
              </>
            ),
          },
          {
            title:
              'Kan jeg lægge en begivenhed ind for en blandesløjfe, der forsyner et enkelt område i bygningen?',
            answer: (
              <>
                Når du indtaster en begivenhed i kalenderfunktionen, kan du
                markere lige nøjagtigt den blandesløjfe, som forsyner det
                område, du gerne vil have varme på til begivenheden.
              </>
            ),
          },
          {
            title:
              'Navngivningen af de enkelte blandesløjfer giver ikke mening',
            answer: (
              <>
                Vi har forsøgt at lave navngivningen af de enkelte blandesløjfer
                gennemskuelig. Skulle I have ønsker til at få ændret navnet, så
                det er nemmere at lave begivenheder, som kun gælder dele af
                bygningen, så ræk ud til vores support, så omdøber vi det
                sammen.
              </>
            ),
          },
          {
            title:
              'Hvordan ser jeg de begivenheder jeg har lagt ind for den kommende måned?',
            answer: (
              <>
                Når du er inde i kalenderoverblikket, kan du oppe i højre hjørne
                skifte kalenderens visning mellem en måned, en uge eller en dag.
              </>
            ),
          },
          {
            title: 'Hvordan sletter jeg en begivenhed?',
            answer: (
              <>
                Hvis du fortryder en begivenhed i kalenderen, kan du altid
                slette den igen ved at trykke på den konkrete begivenhed og
                trykke <b>fjern begivenhed</b>.
              </>
            ),
          },
        ],
      },
    ],
  },
  {
    service: 'DatahubIntegration',
    title: 'DataHub-integration',
    sections: [
      {
        title: 'Generelt',
        questions: [
          {
            title: 'Hvad er formålet med DataHub-integrationen?',
            answer: (
              <>
                Formålet med DataHub-integrationen er at give ReMoni adgang til
                virksomhedens hovedmålerdata (el) fra eloverblik.dk via en
                tredjepartsfuldmagt. Når integrationen er gennemført, bliver
                data automatisk hentet og gjort tilgængelige i ReMoni-portalen
                til videre analyse og visualisering.
              </>
            ),
          },
          {
            title: 'Hvem kontakter jeg, hvis noget går galt?',
            answer: (
              <>
                Hvis du oplever fejl, manglende data eller usædvanlig ventetid
                (over 24 timer), kan du kontakte ReMonis kundeservice for hjælp.
              </>
            ),
          },
        ],
      },
      {
        title: 'Oprettelse',
        questions: [
          {
            title: 'Hvordan opretter jeg en fuldmagt?',
            answer: (
              <>
                Klik på knappen <b>Opret fuldmagt</b> i brugerfladen. Du bliver
                herefter guidet til DataHubs fuldmagtsformular, hvor du skal
                give ReMoni A/S adgang som datamodtager. Fuldmagten skal
                udfyldes af en person med MitID-rettigheder til den virksomhed,
                som målepunkterne tilhører.
              </>
            ),
          },
          {
            title:
              'Hvad gør jeg, hvis jeg ikke selv har adgang til at oprette fuldmagten?',
            answer: (
              <>
                Du kan kopiere linket til fuldmagtsformularen og sende det
                videre til den person i din organisation, der har de nødvendige
                rettigheder (MitID med adgang til virksomhedens hovedmålerdata).
              </>
            ),
          },
          {
            title: 'Kan jeg tilføje flere virksomheder eller kunder?',
            answer: (
              <>
                Ja, du kan oprette flere fuldmagter - én for hver virksomhed
                eller kunde, du ønsker at hente målerdata fra. Du skal blot
                gentage processen og indtaste det relevante CVR-nummer for hver
                virksomhed.
              </>
            ),
          },
          {
            title: 'Hvordan henter jeg data efter oprettelse af fuldmagten?',
            answer: (
              <>
                Efter at fuldmagten er godkendt, skal du indtaste virksomhedens
                <b>CVR-nummer</b> i feltet under <b>Trin 2: Hent data</b>.
                ReMonis system begynder herefter at hente data fra DataHubben.
              </>
            ),
          },
          {
            title:
              'Hvor lang tid går der, før mine data er synlige i portalen? ',
            answer: (
              <>
                Normalt tager det cirka <b>10 minutter</b>, men ved store
                porteføljer kan det tage op til et par timer. Hvis du også har
                <b>porteføljeoverblik</b> aktiveret, kan det tage yderligere
                <b>15 minutter til 1 time</b>, før beregningerne er klar.
              </>
            ),
          },
          {
            title: 'Hvad sker der, hvis DataHubben er offline?',
            answer: (
              <>
                DataHubben kan i sjældne tilfælde være midlertidigt nede. Ofte
                er det kun i få sekunder, men det kan i enkelte tilfælde vare
                længere. Hvis du oplever problemer, kan du prøve at gentage
                processen med at indtaste CVR-nummeret efter et kort stykke tid.
                Integrationer gennemføres typisk inden for <b>24 timer</b>, selv
                ved nedetid. Kontakt ReMoni support, hvis du oplever
                længerevarende problemer
              </>
            ),
          },
          {
            title: 'Hvordan ved jeg, at integrationen er gennemført?',
            answer: (
              <>
                Når integrationen er aktiv, vises virksomheden og CVR-nummeret
                under inputfeltet med et grønt flueben og dato for datoperioden.
                Det indikerer, at dataene er under indhentning eller allerede
                tilgængelige.
              </>
            ),
          },
          {
            title: 'Skal jeg gøre noget for at holde integrationen i gang? ',
            answer: (
              <>
                Nej, når fuldmagten er givet, og CVR-nummeret er indtastet,
                fortsætter ReMonis system med at hente data løbende - så længe
                DataHubben er online og fuldmagten er aktiv.
              </>
            ),
          },
        ],
      },
    ],
  },
];
